// The frame the demo and the editor share: the URL bar, the controls beside the stage, and the
// layout following the width it is given (a page section, an article's column or a dialog), not
// the window's.
.layout {
  container-type: inline-size;
  position: relative;
  margin-bottom: 1.5rem;
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: var(--color-card);

  &[data-variant="docs"] {
    --stage-min: 20rem;
    margin-block: 1.5rem;
  }

  // Inside a dialog or panel that has its own spacing.
  &[data-variant="standard"] {
    --stage-min: 22rem;
    margin: 0;
  }
}

.body {
  display: grid;
  grid-template-columns: 22rem minmax(0, 1fr);
}

.controls {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-inline-end: 1px solid var(--color-border);
}

// The lens the transform is served through: one row of choices across the top, under the URL.
.lenses {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  overflow-x: auto;
  border-bottom: 1px solid var(--color-border);
  scrollbar-width: none;

  h3 {
    flex-shrink: 0;
    margin: 0;
  }
}

.lensList {
  display: flex;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;

  button {
    padding-inline-end: 0.75rem;
    white-space: nowrap;
  }
}

// Rows that are about how the transform is served, not what is in it.
.delivery {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-top: 0.25rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--color-border);
}

.viewer {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

@container (max-width: 760px) {
  .layout {
    --stage-min: 18rem;
  }

  .body {
    grid-template-columns: minmax(0, 1fr);
  }

  .controls {
    border-inline-end: 0;
    border-bottom: 1px solid var(--color-border);
  }
}
